import React, { useState , useEffect} from 'react';
import { ToastContainer , toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

import {axiosApiInstance} from '../../../services/axios';
import ModalRemoveAffiliateReqs from '../../common/modals/modalRemoveAffiliateReqs/ModalRemoveAffiliateReqs';
import Button from "../../common/button/Button" ;
import Pagination from '../../common/pagination/Pagination';
import Loading from '../../common/loading/Loading';


const AffiliateReqs = () => {

    const navigate = useNavigate();

    const [showModalRemove , setShowModalRemove] = useState(false);
    const[loading , setLoading] = useState(true);
    const [reqs , setReqs ] = useState();
    const [page, setPage] = useState();
    const [pages, setPages] = useState();
    const [currentReq , setCurrentReq] = useState({});


    useEffect(()=>{

        const getUsers = async()=>{
            const res = await axiosApiInstance.get('/admin/affiliate-reqs' );
            setLoading(false);
            if(res.data.status === 'success'){
                setReqs(res.data.data.affiliateReqs);
                setPage(res.data.data.affiliateReqs.page);
                setPages(res.data.data.affiliateReqs.pages);

            }else if(res.data.status === 'error'){
                toast.error(res.data.msg);
            }
        }

        getUsers();

    } , []);


    const stateModalRemove = (state , item) => {
        setShowModalRemove(state);
        setCurrentReq(item);
    }


    const goPage = async (p) => {
        setLoading(true);
        const res = await axiosApiInstance.get(`/admin/affiliate-reqs?page=${p}`);
        setLoading(false);
        if (res.data.status === 'success') {
            setReqs(res.data.data.affiliateReqs);
            setPage(res.data.data.affiliateReqs.page);
            setPages(res.data.data.affiliateReqs.pages);
        } else {
            toast.error(res.data.msg);
        }
    }


    const refresh = () => {
        goPage(page);
    }

    return (
        <>
            <ModalRemoveAffiliateReqs show={showModalRemove} close={()=>setShowModalRemove(false)} refresh={() => refresh()} item={currentReq}/>

            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

            <div className="container mx-auto p-3 ">

                <div className='bg-white-100 dark:bg-dark-100 p-3 rounded-md text-[0.9rem] font-normal flex flex-col justify-center items-start shadow-my dark:shadow-none '>

                    <div className='w-full flex justify-start items-center mb-5'>
                        <svg className='w-2 h-2 fill-gray-700 dark:fill-white-100 mr-2' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="50" cy="50" r="50" />
                        </svg>
                        <span className='text-gray-700 dark:text-white-100 text-xl font-extrabold'>Affiliate Requests</span>
                    </div>
                    {
                        loading ? 
                        (
                            <Loading/>
                        )
                        :
                        (
                            <div className='w-full flex flex-col justify-center items-start'>
                                <div className='text-base font-semibold	 mb-4 text-slate-600 dark:text-white-100'>
                                    List of all Affiliate Requests
                                </div>
                                <div className='w-full text-[0.9rem] font-normal text-center border-collapse overflow-x-auto'>
                                    {reqs.docs.length > 0 ?
                                        (
                                            <>
                                                <table className="w-full table">
                                                    <thead>
                                                        <tr>
                                                            <th className='min-w-[120px] font-bold text-gray-800 text-[1rem] border-none align-middle h-20'>User</th>
                                                            <th className='min-w-[120px] font-bold text-gray-800 text-[1rem] border-none  align-middle h-20'>Name</th>
                                                            <th className='min-w-[120px] font-bold text-gray-800 text-[1rem] border-none align-middle h-20'>Phone</th>
                                                            <th className='min-w-[120px] font-bold text-gray-800 text-[1rem] border-none align-middle h-20'>Email</th>
                                                            <th className='min-w-[120px] font-bold text-gray-800 text-[1rem] border-none align-middle h-20'>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        { reqs.docs.map ((req , index) =>(
                                                            <tr key={index} className="hover:bg-stone-100">
                                                                <td className='font-normal text-gray-700 text-[1rem] font-semibold border-none align-middle h-20'>
                                                                    <div className="w-full flex flex-col justify-center items-center">
                                                                        <img className='rounded-full' src={`${process.env.REACT_APP_BACK_END_URL}${req.user?.avatar?.thumb}`} width="64" height="64" alt='user' />
                                                                        <span className=''>
                                                                            {
                                                                            req.user.name !== "" ? req.user.name : req.user.phone
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td className='font-normal text-gray-700 text-[1rem] font-semibold border-none align-middle h-20'>{req.name}</td>
                                                                <td className='font-normal text-gray-700 text-[1rem] font-semibold border-none align-middle h-20'>{req.phone}</td>
                                                                <td className='font-normal text-gray-700 text-[1rem] font-semibold border-none align-middle h-20'>{req.email}</td>

                                                                <td className='flex items-center justify-center font-normal text-gray-700 text-[1rem] font-semibold border-none align-middle h-20'>
                                                                    <Button classes="px-2 py-1 mr-2 bg-yellow-400" click={()=>navigate(`/affiliate-requests/${req.id}`)}>
                                                                        Show detail
                                                                    </Button>
                                                                    <Button classes="px-2 py-1 bg-red-600" click={()=>stateModalRemove(true , req)}>
                                                                        Remove
                                                                    </Button> 
                                                                </td>
                                                            </tr>
                                                            )
                                                        )
                                                        }
                                                    </tbody>
                                                </table>
                                                <Pagination pages={pages} current={page} action={goPage} />
                                            </>
                                        )
                                        :
                                        (
                                            <p className="caption-no-result">
                                                No items found
                                            </p>
                                        )
                                    }
                                </div>
                            </div> 
                        )
                    }
                </div>

            </div>
        </>
    )

}

export default AffiliateReqs ;
